import React, { useEffect, useState } from 'react'
import { PieChartWrapper } from '../dashboard.styled'
import { Pie } from 'react-chartjs-2'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import styled from 'styled-components'
import { DashboardSources, DefaultColor } from '../../../constants/DashboardConf'
import ChartHeader from './ChartHeader'

const LegendWrapper = styled.div`
  max-height: 46px;
  margin: 16px 0px 8px;
  overflow: scroll;
  display: flex;
  flex-wrap: wrap;
  gap: 4px 8px;
  justify-content: center;

  &::-webkit-scrollbar {
    display: none;
  }
`

const LegendItem = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`

const Circle = styled.div`
  ${({ color }) => `background: ${color || 'rgba(0,0,0,.5)'}`};
  width: 6px;
  height: 6px;
  border-radius: 50%;
`

function PieChart (props) {
  const { data: d, settingMode, useFakeData } = props
  const { title, UISetting, tableName, categoryDetail, content } = d || {}
  const { groupBy, limit, style } = UISetting || {}
  const [dataset, setDataset] = useState([])
  const [labels, setLabels] = useState([])
  const [total, setTotal] = useState({})
  const [multipleTitle, setMultipleTitle] = useState([])
  const neededMoreColor = Math.ceil(content?.data?.length / 20) || 1
  const theme = Object.values(style?.themeColor || {})
  const color = theme?.length ? theme : DefaultColor
  const colorTheme = Array(neededMoreColor).fill(color).flat()

  const options = {
    plugins: {
      datalabels: {
        formatter: (value, context) => {
          const totalItem = total[context?.dataset?.label] || total.value || 0
          return `${Math.round((value / totalItem) * 1000) / 10 || 0}%`
        },
        color: 'rgba(0,0,0,.45)',
        font: { weight: 'bold' }
      }
    },
    tooltips: { displayColors: false },
    legend: { display: false },
    borderWidth: 0,
    radius: '95%'
  }

  const defaultConf = { hoverOffset: 4 }
  const data = {
    datasets: multipleTitle?.length
      ? multipleTitle?.map((title, idx) => ({
        label: title,
        data: dataset?.map(i => Number(i[title])),
        backgroundColor: colorTheme,
        ...defaultConf
      }))
      : [{
          label: title,
          data: dataset?.map(i => Number(i.value)),
          backgroundColor: colorTheme,
          ...defaultConf
        }],
    labels
  }

  const useFake = useFakeData && categoryDetail === DashboardSources.THIRD_PARTY
  useEffect(() => {
    if (!settingMode && !useFake && !content?.data) return
    const fakeData = Array.from({ length: limit || 5 }, (v, i) => ({ label: `${groupBy || tableName || categoryDetail} ${i + 1}`, value: (i + 1) * 10 }))
    const pieData = settingMode || useFake ? fakeData : content?.data
    setDataset(pieData)
    setLabels(pieData.map(i => i.label))
    const titles = Object.keys(content?.data?.[0] || [])?.filter(i => i !== 'label' && i !== 'value')
    setMultipleTitle(titles)
    const titleTotal = [...titles?.length ? titles : ['value']].reduce((all, item) => ({
      ...all,
      [item]: pieData.reduce((a, i) => a + Number(i[item] || 0), 0)
    }), {})
    setTotal(titleTotal)
  }, [content])

  return (
    <>
      <ChartHeader {...props} />
      <PieChartWrapper>
        <Pie height={200} data={data} options={options} plugins={[ChartDataLabels]} />
        <LegendWrapper>
          {data?.labels.map((label, index) => <LegendItem key={index}>
            <Circle color={data.datasets[0]?.backgroundColor[index]}/>
            <span>{label}</span>
          </LegendItem>)}
        </LegendWrapper>
      </PieChartWrapper>
    </>
  )
}

export default PieChart
